import type { ComponentProps } from 'react'
import { buttonVariants, DropdownMenuItem } from '@teach/ui'
import { cn } from '@/lib/utils'

type Props = Omit<ComponentProps<typeof DropdownMenuItem>, 'onSelect'> & {
  variant?: 'default' | 'outline' | 'ghost'
  size?: 'sm' | 'icon-sm'
  /** Действие пункта. Меню он НЕ закрывает: закрывает тот, кто открывает
   *  диалог (`closeMenu`), — иначе после старта автор не увидел бы ни
   *  полосы, ни отказа на месте панели. */
  onSelect: () => void
}

/**
 * Кнопка подвала меню языка — пункт меню, одетый кнопкой. Обычная `<button>`
 * внутри `DropdownMenuContent` с клавиатуры недостижима: Radix гасит Tab, а
 * стрелки ходят только по пунктам. Пункт получает стрелки и Enter/пробел, а
 * вид кнопки ему возвращает `buttonVariants` (twMerge в `cn` пункта
 * перебивает его собственные отступы и шрифт).
 */
export const MenuButton = ({
  variant = 'outline',
  size = 'sm',
  className,
  onSelect,
  ...item
}: Props) => (
  <DropdownMenuItem
    className={cn(
      buttonVariants({ variant, size }),
      'cursor-pointer justify-center text-center focus-visible:ring-0 focus-visible:ring-offset-0',
      // Пункт меню получает фокус при наведении: у брендовой кнопки фокус темнит
      // фиолетовый (как hover кнопки дизайн-системы), а не красит её в серый.
      variant === 'default'
        ? 'focus:bg-brand-hover focus:text-brand-foreground'
        : 'focus:bg-foreground/10',
      size === 'sm' && 'w-full',
      className,
    )}
    onSelect={(e) => {
      e.preventDefault()
      onSelect()
    }}
    {...item}
  />
)
